module.exports = "<section class=\"wrap-loader\" *ngIf=\"showIntermediateLoader || showLoader\">\n    <div class=\"loader\">{{loaderText}}\n    </div>\n  </section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.html
// module id = ./src/app/components/loader/loader.html
// module chunks = main